import { StatusResult } from '../shared/enum/StatusResult';

export interface NewsSpreadsheetUploadResultModel {
    id: number,
    quantityInserted: number,
    quantityDuplicated: number,
    quantityTotal: number,  
    message: string,
    title: string,
    property: string,
    status: StatusResult,
    registeredMessage:string
}

export const newsSpreadsheetUploadResultInitial: NewsSpreadsheetUploadResultModel = {
    id: 0,
    quantityInserted: 0,
    quantityDuplicated: 0,
    quantityTotal: 0,
    message: '',
    title: '',
    property: '', 
    status: StatusResult.DEFAULT,
    registeredMessage: ''
};